export default __webpack_public_path__ + "static/media/repayment-channel-icon5.cd086ba2.png";